// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from '@rails/ujs'
import * as ActiveStorage from '@rails/activestorage'
import 'channels'
import 'jquery-ui'
import 'jqgrid'
import 'jqgrid-locale-ja'
// import 'free-jqgrid/dist/css/ui.jqgrid.css'
import 'bootstrap'

Rails.start()
ActiveStorage.start()

// =================================================================================================
//   Initialize sortable table
// =================================================================================================
$(() => {
  const CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content')

  $('.table-sortable').sortable({
    axis: 'y',
    items: '.item',
    start: (e, ui) => {
      const table_width = $(this).width()
      const cells = ui.item.children('td')
      cells.css('width', table_width / cells.length + 'px')
    },
    stop: (e, ui) => {
      ui.item.children('td')
        .css('width', '')
        .effect('highlight')
    },
    update: (e, ui) => {
      const item = ui.item
      const item_data = item.data()
      let params = { _method: 'put' }
      params[item_data.modelName] = { row_order_position: item.index() }

      $.ajax({
        type: 'POST',
        url: item_data.updateUrl,
        headers: {
          'X-CSRF-TOKEN': CSRF_TOKEN
        },
        dataType: 'json',
        data: params
      })
    }
  })
})

// =================================================================================================
//   Initialize jqGrid
// =================================================================================================
$(() => {
  const target = $('#price-list')

  if (target.length) {
    const price_list_id = target.data('price-list-id')
    let lastsel2

    $.ajax({
      url: '/ajax/price_list.json',
      type: 'GET',
      data: { price_list_id: price_list_id },
      dataType: 'json',
      success: data => {
        target.jqGrid({
          datatype: 'local',
          // height: 300,
          colNames: data.col_names,
          colModel: data.col_model,
          guiStyle: 'bootstrapPrimary',
          iconSet: 'fontAwesome',
          // autoresizeOnLoad: true,
          minColWidth: 50,
          editurl: '/manage/driver_license_price_lists/ajax_update',
          width: 960,
          shrinkToFit: false,
          autoWidth: true,
          caption: data.name,
          onSelectRow: function (id) {
            if (id && id !== lastsel2) {
              target.jqGrid('restoreRow', lastsel2)
              target.jqGrid('editRow', id, true)
              lastsel2 = id
            }
          },
        })

        for (let row of data.price_data) {
          target.addRowData(row.id, row)
        }
      },
      error: data => { console.error('[error]', data.responseText) }
    })
  }
})
